import styled from 'styled-components';
import { Dark_Gray, White} from '../../colors';

export const Container = styled.div`
    width: 100vw;
    height: 100vh;
    position: relative;
    margin-top: -40%;

    @media (max-width: 2560px){
        margin-top: calc(100vh - 40%);
    }
    
    @media (max-width: 1201px){
        margin-top: calc(90vh - 40%);
    }

    @media (max-width: 1000px){
        margin-top: 15vh;
        height: auto;
    }

    @media (max-height: 700px){
        height: auto;
    }
`;

export const ImageInteractive = styled.div`
    width: 80vw;
    max-width: 1200px;
    padding-top: 40vh;
    background-image: url(${(props) => props.src});
    background-repeat: no-repeat;
    margin: 0 auto;
    display:flex;
    justify-content: center;
    
    @media (max-width: 2560px){
        background-size: calc(100% - 25vw);
    }

    @media (max-width: 1200px){
        padding-top: calc(70vh - 40%);
        height: 100%;
    }
    @media (max-width: 1000px){
        width: 100%;
        margin: 0 2.5em;
        background-size: 80vw;
        
    }
`;
export const TextAbout = styled.p`
    font-family: 'Alata';
    width: 60vw;
    align-items: center;
    text-align: center;
    padding-top: 3rem;
    margin: 0 20%;
    display:flex;
    color: ${Dark_Gray};
    justify-content: center;
    @media (min-width: 1000px){
        max-width: 40vw;
        text-align: left;
    }
    @media (max-width: 2560px){
        width: 25vw;
        height: 25vh;
    }

    @media (max-width: 1000px){
        width: 60vw;
        height: 25vh;
    }
`;

export const TextArea = styled.div`
    @media (min-width: 1000px){
        position: absolute;
        right: 10%;
        background-color: ${White};
        max-width: 40vw;
        top: 51%; //chave
    }
    @media (max-width: 2560px){
        top: calc(100vh - 75vh);
        right: 20%;
    }

    @media (max-width: 1800px){
        top: 50%;
    }

    @media (max-width: 1200px){
        top: 40%;
    }

    @media (max-width: 1000px){
        top: 0;
        
    }
    @media (max-height: 700px){

    }
`;

export const Leader = styled.h1`
    text-transform: uppercase;
    font-family: 'Josefin Sans';
    text-align: center;
    padding-top: 3rem;
    margin: 0 22%;
    display:flex;
    justify-content: center;
    @media (min-width: 1000px){
        text-align: left;
        width: 30vw;
    }
    @media (max-width: 2560px){
        margin: 0 14%;
      
    }

    
`;